import type { ReactNode } from 'react';

/** Üst menü: modüller başlığın orta alanında (TopNavBar AppHeader `center` yuvasına verilir); içerik tam genişlikte. */
export function TopNavLayout({ children }: { children: ReactNode }) {
  return <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">{children}</main>;
}
